// extracted by mini-css-extract-plugin
export var colorSquare = "_sw-0";
export var danger = "_sw-5";
export var lightPink = "_sw-8";
export var neutralBlue = "_sw-7";
export var neutralYellow = "_sw-6";
export var normal = "_sw-1";
export var primary = "_sw-2";
export var primaryLight = "_sw-3";
export var solidBlack = "_sw-g";
export var solidGreen = "_sw-b";
export var solidLightBlue = "_sw-d";
export var solidNavy = "_sw-c";
export var solidOrange = "_sw-f";
export var solidPink = "_sw-e";
export var solidRed = "_sw-9";
export var solidYellow = "_sw-a";
export var success = "_sw-4";